import React from 'react';

import { UseFormRegister } from 'react-hook-form';

import Input from '~/src/common/components/Form/Input';
import * as validation from '~/src/common/components/Form/validation';
import Icon from '~/src/common/components/Icon';
import I18n from '~/src/common/services/I18n/I18n';

import { ArrowCTA, FormInputContainer, SuccessMessage, EmailInput, Title } from './layout';
import { ContactEmailFormData } from './types';

interface Props {
  isLoadingWaitingList: boolean;
  register: UseFormRegister<ContactEmailFormData>;
  emailError: string | undefined;
  isEmailSent: boolean;
}

const ProspectEmailFormContent = ({
  isLoadingWaitingList,
  register,
  emailError,
  isEmailSent,
}: Props) => {
  if (isEmailSent) {
    return (
      <SuccessMessage>
        <Icon name="valid-big" size={24} />
        {I18n.translate({ value: 'prospect-email-form.waiting-list-success' })}
      </SuccessMessage>
    );
  }

  return (
    <>
      <Title>{I18n.translate({ value: 'prospect-email-form.contact-me' })}</Title>
      <EmailInput>
        <FormInputContainer error={emailError}>
          <Input
            {...register('email', {
              required: validation.required(),
              validate: validation.email(),
            })}
            placeholder={I18n.t('prospect-email-form.email-placeholder')}
          />
        </FormInputContainer>
        <ArrowCTA
          loading={isLoadingWaitingList}
          icon="chevron-right"
          type="submit"
          disabled={!!emailError}
        />
      </EmailInput>
    </>
  );
};
export default ProspectEmailFormContent;
